import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ActionType } from 'typesafe-actions'

/** What `DepositAccountProvider`'s `openDepositTopupRequest` dispatches. */
export type TDepositTopupRequest = {
  partyId: string
  portfolioId: string
}

const initialState = {
  searchQuery: '',
  depositTransferModal: false,
  isDepositTopupRequestOpen: false,
}

const contactsSlice = createSlice({
  name: 'contacts',
  initialState,
  reducers: {
    init: () => {},
    searchQueryUpdated: (state, { payload }: PayloadAction<string>) => {
      state.searchQuery = payload
    },
    openDepositTransferModal: (state, { payload }) => {
      state.depositTransferModal = payload
    },
    closeDepositTransferModal: state => {
      state.depositTransferModal = false
    },
    // The payload is not stored, but it is what `openDepositTopupRequestModal` builds the
    // adhoc-invoice initial values from — declaring it is what types that epic.
    depositTopupRequestOpened: (state, _action: PayloadAction<TDepositTopupRequest>) => {
      state.isDepositTopupRequestOpen = true
    },
    depositTopupRequestClosed: state => {
      state.isDepositTopupRequestOpen = false
    },
  },
})

/**
 * Exports
 */
const { reducer, actions: events } = contactsSlice

export type ContactsEvent = ActionType<typeof events>

export { events, reducer }
